export default __webpack_public_path__ + "static/media/Histórico.1e5da9a0.svg";